import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DonationsReport } from '../../../../shared/Models/DonationsReport';
import { ProjectsService } from '../../../../shared/API-Service/services/projects.service';
 @Component({
  selector: 'app-donations',
  templateUrl: './donations-reports.component.html',
  styleUrls: ['./donations-reports.component.css']
})
export class DonationsReportComponent implements OnInit {
  ReportsInfo = new DonationsReport()
  currentUser: any;
  projects: any;

  constructor(private router: Router,private ProjectsService:ProjectsService) {
  
  }
  ngOnInit(): void {
    this.GetProjects();
  }
  GetProjects(){
    this.ProjectsService.GetProjects().subscribe(res=>{
      this.projects=res.data
    })
  }


  SelectProject(event:any){
    this.ReportsInfo.ProjectId = parseInt(event) 
    this.ReportsInfo.ProjectName = this.projects.find((x:any) => x.id == event)?.titleAr
   }

  Viewreports() {

    localStorage["ReportName"] = "DonationsReport";
  
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));
    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }

}
